import React, {Component} from 'react'
import {Panel, FormGroup, ControlLabel, FormControl} from 'react-bootstrap'
import {connect} from 'react-redux'
import {Form, Errors, Control, actions} from 'react-redux-form'
import {Link} from 'react-router-dom'
import ArrowButton from '../../../common/button-arrow'
import PasswordMaskInput from '../../../common/form/elements/password-mask-input'
import ErrorMessages from '../error-messages'
import {adminLogin as loginAction} from '../../../../actions/login'

import './login-form.css'

class AdminLoginForm extends Component {

    handleSubmit = (payLoad) => {
        const {dispatch} = this.props;
        dispatch(actions.submit('deep.login', loginAction(payLoad, dispatch)))
    };

    render() {
        return (
          <Form model="deep.login" onSubmit={this.handleSubmit}>
            <Errors className="errors" model="deep.login" component={ErrorMessages}/>
            <Panel header={<h2 className="text-uppercase">Login</h2>}
                   footer={<ArrowButton color="red" className="btn-block">Login</ArrowButton>}
                   className="login" bsStyle="primary">
                  <FormGroup>
                      <ControlLabel>E-mail or mobile:</ControlLabel>
                      <Control.text
                        model=".login"
                        component={FormControl}/>
                  </FormGroup>

                  <FormGroup>
                    <ControlLabel>Password:</ControlLabel>
                    <Control
                      model=".password"
                      component={PasswordMaskInput}/>
                  </FormGroup>

                  <div id="forgottenPasswordLabel">Forgotten password? <Link to={'/reset-password'}>Click here</Link></div>
            </Panel>
          </Form>
        );
    }
}

function mapStateToProps(state) {
    return {login: state.deep.login};
}

export default connect(mapStateToProps)(AdminLoginForm);



// WEBPACK FOOTER //
// ./src/components/admin/login/login-form/index.jsx